import Card from '../templates/ui/Card'
import Button from '../templates/ui/Button'
import { useCampaignStore } from '../app/store/campaignStore'

export default function AdminMock() {
  const { resetAll } = useCampaignStore()

  return (
    <section className="mobile-page">
      <h1 className="text-2xl font-extrabold text-[#2f6d17]">Admin Mock</h1>
      <Card className="mobile-panel">
        <Button
          onClick={() => {
            resetAll()
          }}
        >
          Reset State
        </Button>
      </Card>
    </section>
  )
}
